module.exports = __webpack_public_path__ + "img/31.f4bffd88.jpg";